import { millsToTimeString } from 'src/helpers/date-helpers';
import { DropdownOption } from 'uikit/inputs/dropdown/appDropdownInput';

export const getTimeInputOptions = (
  timeEntriesIntervalInMinutes = 30,
  minTimeInMills = 0,
): DropdownOption<number>[] => {
  const totalMillsInADay = 24 * 60 * 60000;
  const intervalInMills = timeEntriesIntervalInMinutes * 60000;

  return [...Array(Math.round(totalMillsInADay / intervalInMills))]
    .map((_, index) => {
      const timeInMills = index * intervalInMills;

      return {
        key: timeInMills,
        text: millsToTimeString(timeInMills),
      };
    })
    .filter((option) => option.key >= minTimeInMills);
};
